type Status = 'in_field' | 'delayed' | 'absent' | 'finished' | 'in_transit';

const statusConfig: Record<Status, { bg: string; text: string; label: string }> = {
  in_field: { bg: 'bg-green-100', text: 'text-green-700', label: 'Em campo' },
  delayed: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Atrasado' },
  absent: { bg: 'bg-red-100', text: 'text-red-700', label: 'Ausente' },
  finished: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Finalizado' },
  in_transit: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Deslocamento' },
};

export default function StatusBadge({ status }: { status: Status }) {
  const config = statusConfig[status] || statusConfig.absent;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
}
